/* eslint-disable import/prefer-default-export */
import QueriesKeys from "constants/queryKeys";
import { useQuery } from "react-query";
import { getCandidateJobDetails } from "utils/apiClientPrivate";
import { candidateJobDetailsParser } from "../utils/parsers";

export const useJobDetails = (phoneNumber) =>
	useQuery<unknown>(
		QueriesKeys.GET_CANDIDATE_JOB_DETAILS,
		async () => {
			const { data } = await getCandidateJobDetails();
			return candidateJobDetailsParser(data);
		},
		{
			enabled: !!phoneNumber,
			retry: false,
		}
	);
